<template>
  <div class="roadtrip__questions">
    <div
      class="roadtrip__question"
      :data-answers-length="questions[currentQuestion].answers.length"
      :data-current-question="currentQuestion"
    >
      <h1>{{ questions[currentQuestion].question }}</h1>

      <Answers :key="currentQuestion"></Answers>

      <div class="roadtrip-question__buttons">
        <div class="roadtrip-question__buttons-inner">
          <button
            type="button"
            class="btn btn--next"
            @click="next"
            v-if="questions[currentQuestion + 1] && currentQuestion > 0"
            :disabled="!chosenAnswer"
            :class="{ 'btn--disabled': !chosenAnswer }"
          >
            Next
          </button>
          <button
            type="button"
            class="btn btn--next"
            @click="next"
            v-if="currentQuestion === 0"
            :disabled="!chosenAnswer"
            :class="{ 'btn--disabled': !chosenAnswer }"
          >
            I want to personalise my trip
          </button>

          <button
            type="button"
            class="btn btn--next"
            @click="finish"
            v-if="currentQuestion === questions.length - 1"
            :disabled="!chosenAnswer"
            :class="{ 'btn--disabled': !chosenAnswer }"
          >
            Show me my results
          </button>

          <button
            type="button"
            class="btn btn--black-border"
            @click="finish"
            v-if="currentQuestion === 0"
            :disabled="!chosenAnswer"
            :class="{ 'btn--disabled': !chosenAnswer }"
          >
            Anywhere in this country – surprise me
          </button>
          <button type="button" class="btn btn--black-border" @click="startAgain" v-if="currentQuestion >= 1">
            Start again
          </button>
        </div>

        <div class="roadtrip__skip">
          <button
            type="button"
            class="arrow-link"
            @click="finish"
            v-if="
              (currentQuestion >= 1 && additionalQuestion === false) ||
              (additionalQuestion === true && currentQuestion >= 1)
            "
          >
            Skip to results
          </button>
        </div>
      </div>
    </div>
    <span class="roadtrip__loader">
      <img src="/Static/images/roadtrip/pig.PNG" alt="" class="" />
    </span>
  </div>
</template>

<script>
import Answers from './Answers.vue';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'Questions',

  components: {
    Answers,
  },

  created() {
    if (window.innerWidth > 991) {
      this.desktop = true;
    }
  },

  computed: {
    ...mapState('roadtrip', ['step', 'questions', 'currentQuestion', 'additionalQuestion']),
    ...mapGetters('roadtrip', ['chosenAnswer']),
  },

  methods: {
    answered: function (answer) {
      this.$store.commit('roadtrip/selectAnswer', answer);
    },
    next() {
      document.querySelector('.roadtrip__question').classList.add('roadtrip__question--fade');
      const $this = this;
      document.querySelector('.roadtrip__loader').classList.add('roadtrip__loader--active');

      setTimeout(function () {
        // Store link if one is assigned to that step (region question)
        if ($this.chosenAnswer.link) {
          $this.$store.commit('roadtrip/addLink', $this.chosenAnswer.link);
        }
        $this.$store.commit('roadtrip/addAnswer', $this.chosenAnswer);
        document.querySelector('.roadtrip__question').classList.add('roadtrip__question--right');
      }, 500);
      setTimeout(function () {
        document
          .querySelector('.roadtrip__question')
          .classList.remove('roadtrip__question--fade', 'roadtrip__question--right');
      }, 1000);
      setTimeout(function () {
        document.querySelector('.roadtrip__loader').classList.remove('roadtrip__loader--active');
      }, 1200);
    },

    startAgain() {
      location.reload();
    },

    finish() {
      if (this.chosenAnswer && this.chosenAnswer.link) {
        this.$store.commit('roadtrip/addLink', this.chosenAnswer.link);
      }
      this.$store.commit('roadtrip/setStep', 'results');
      if (this.chosenAnswer) {
        this.$store.commit('roadtrip/addAnswer', this.chosenAnswer);
      }
    },
  },
};
</script>

<style lang="scss">
.roadtrip__questions {
  position: relative;
  padding: 5rem 0;

  @media only screen and (min-width: 768px) {
    padding: 5rem 0 0;
  }

  @media only screen and (min-width: 992px) {
    padding: 7.5rem 0 0;
  }
}

@keyframes grow {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.07);
  }
  100% {
    transform: scale(1);
  }
}

.roadtrip__loader {
  display: block;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -125px;
  margin-left: -100px;
  width: 200px;
  height: 250px;
  z-index: -1;
  animation: grow 1s;
  animation-iteration-count: infinite;
  opacity: 0;

  &.roadtrip__loader--active {
    opacity: 1;
  }

  @media only screen and (min-width: 768px) {
    margin-top: -150px;
    margin-left: -165px;
    width: 380px;
    height: 300px;
  }
}

.roadtrip__question {
  transition: opacity 0.5s ease, transform 0.5s ease;
  opacity: 1;
  transform: translateX(0);
  background: $white;
  min-height: 75vh;
}
.roadtrip__question--fade {
  opacity: 0;
  transform: translateX(-120%);
}

.roadtrip__question--right {
  transform: translateX(120%);
}

.roadtrip__skip {
  margin-top: 2.4rem;

  @media only screen and (min-width: 992px) {
    margin-top: 4rem;
  }
}

.roadtrip-question__buttons {
  display: block;

  @media only screen and (min-width: 481px) {
    display: inline-block;
  }
}

.roadtrip-question__buttons-inner {
  margin: 0 auto;

  .btn {
    @media only screen and (min-width: 481px) {
      margin-left: 1rem;
      margin-right: 1rem;
    }

    @media only screen and (max-width: 480px) {
      display: block;
      min-width: 20rem;
      margin-bottom: 2.4rem;
      width: 100%;
    }
  }

  @media only screen and (min-width: 481px) {
    display: flex;
  }

  .btn--next {
    @media only screen and (min-width: 481px) {
      order: 1;
    }
  }
}
.btn[disabled],
.btn:disabled,
.btn--disabled {
  opacity: 0.7;
  pointer-events: none;
}

.btn--disabled {
  &:focus,
  &:hover {
    background: $green !important;
    border-color: $green !important;
  }

  &.btn--black-border {
    &:focus,
    &:hover {
      background: $white !important;
      border-color: $black !important;
    }
  }
}
</style>
